import { createSelector } from 'reselect'
import _ from 'lodash'

import { filterLeagueIds } from './index'

const getCategories = state => state.categories
const getFilters = state => state.filters
const getLeaguesById = state => state.leagues
const getIsSimGolf = state => state.misc.isSimGolf

const getVisibleCategoryIds = createSelector(
  [ getCategories, getFilters, getLeaguesById, getIsSimGolf ],
  (categoriesById, filters, leaguesById, isSimGolf) => {
    let categoryIds = _.keys(categoriesById)
    const categoryFilter = filters.category
    if (categoryFilter !== 'all') {
      categoryIds = categoryIds.filter(categoryId => (
        categoryId === categoryFilter
      ))
    }

    const hasActiveLeagueFilter = filters.leagueName.length > 0 ||
      (isSimGolf && filters.registration !== 'all')

    // While a league filter is active, only show categories with at least one matching league
    if (hasActiveLeagueFilter) {
      categoryIds = categoryIds.filter(categoryId => {
        const leagueIds = categoriesById[categoryId].leagues
        return filterLeagueIds(leagueIds, leaguesById, categoriesById, filters, isSimGolf).length > 0
      })
    }

    return categoryIds
  },
)

export default getVisibleCategoryIds
